import React from 'react';

const HopeIcon = () => (
  <svg
    width={80}
    height={80}
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1633_1333)">
      <path
        d="M7.80904 20H2.94835C2.82015 20 2.71733 19.8933 2.71733 19.7634C2.71733 19.6334 2.82149 19.5267 2.94835 19.5267H7.34567V15.3974H0.230895C0.1027 15.3974 -0.00012207 15.2907 -0.00012207 15.1607C-0.00012207 15.0308 0.104036 14.9241 0.230895 14.9241H7.80771V20.0014L7.80904 20Z"
        fill="#0A3887"
      />
      <path
        d="M11.628 19.3927C11.5586 19.3927 11.5092 19.39 11.4865 19.3886C11.4745 19.3886 11.4611 19.3886 11.4477 19.3886H7.57655C7.44435 19.3886 7.33618 19.2778 7.33618 19.1424C7.33618 19.007 7.44435 18.8962 7.57655 18.8962H11.4477C11.4691 18.8962 11.4905 18.8962 11.5118 18.8976C11.6801 18.9071 13.1971 18.9577 14.8436 17.8115L20.6857 14.0911C20.874 13.9707 21.0036 13.7833 21.053 13.5631C21.1024 13.3429 21.0636 13.1159 20.9461 12.9244C20.7071 12.5386 20.2037 12.4196 19.8231 12.6563L15.2495 15.515C15.136 15.5861 14.9878 15.5492 14.9197 15.4329C14.8502 15.3167 14.8863 15.1648 14.9998 15.0951L19.5734 12.2364C20.1756 11.8602 20.9742 12.0503 21.3521 12.6604C21.5404 12.964 21.6005 13.3238 21.5217 13.6726C21.4442 14.0227 21.2372 14.3195 20.9395 14.5083L15.1053 18.2232C13.5643 19.2956 12.1021 19.3913 11.628 19.3913V19.3927Z"
        fill="#0A3887"
      />
      <path
        d="M14.02 16.9347H7.57686C7.44466 16.9347 7.3365 16.8239 7.3365 16.6885C7.3365 16.5531 7.44466 16.4423 7.57686 16.4423H14.02C14.4112 16.4423 14.729 16.1168 14.729 15.716C14.729 15.3153 14.4112 14.9911 14.02 14.9911H8.95629C8.7226 14.9911 8.49559 15.0608 8.30063 15.1949L7.7104 15.5984C7.59956 15.6736 7.45134 15.6435 7.37656 15.53C7.30311 15.4165 7.33249 15.2646 7.44333 15.188L8.03355 14.7845C8.3073 14.5972 8.62645 14.4987 8.95629 14.4987H14.02C14.6756 14.4987 15.2084 15.0444 15.2084 15.716C15.2084 16.3876 14.6756 16.9347 14.02 16.9347Z"
        fill="#0A3887"
      />
      <path
        d="M13.5751 13.5561C13.4469 13.5561 13.3441 13.4495 13.3441 13.3195V3.68062C13.3441 3.54931 13.4482 3.44399 13.5751 3.44399C13.7019 3.44399 13.8061 3.55068 13.8061 3.68062V13.3182C13.8061 13.4495 13.7019 13.5548 13.5751 13.5548V13.5561Z"
        fill="#0A3887"
      />
      <path
        d="M13.5754 13.7012C13.5754 13.7012 13.57 13.7012 13.5687 13.7012C13.4405 13.6971 13.3403 13.5877 13.3443 13.4577C13.3484 13.3169 13.3924 10.0943 10.1155 9.01649C9.99394 8.97683 9.92717 8.84278 9.96589 8.71831C10.0046 8.59384 10.1355 8.52545 10.257 8.56512C13.8745 9.75511 13.809 13.4345 13.8077 13.4714C13.8037 13.6 13.7009 13.7012 13.5767 13.7012H13.5754Z"
        fill="#0A3887"
      />
      <path
        d="M13.5753 13.701C13.4525 13.701 13.3496 13.6012 13.3443 13.474C13.3416 13.4138 13.2855 11.9694 13.6648 10.3595C14.1762 8.18607 15.2432 6.77586 16.7535 6.27935C16.875 6.23968 17.0058 6.30807 17.0446 6.43254C17.0833 6.55701 17.0165 6.69106 16.895 6.73072C13.6114 7.80992 13.805 13.396 13.8077 13.4535C13.813 13.5848 13.7142 13.6942 13.586 13.701C13.582 13.701 13.5793 13.701 13.5753 13.701Z"
        fill="#0A3887"
      />
      <path
        d="M13.5725 5.95245C13.4136 5.95245 13.2694 5.87038 13.1853 5.7336L11.6483 3.22642C11.5548 3.07459 11.5548 2.879 11.6483 2.72717L13.184 0.218622C13.2681 0.0818416 13.4136 -0.000226498 13.5712 -0.000226498C13.7288 -0.000226498 13.8743 0.0818416 13.9585 0.218622L15.4955 2.7258C15.5889 2.87763 15.5889 3.07322 15.4955 3.22505L13.9585 5.73223C13.8743 5.86901 13.7288 5.95108 13.5712 5.95108L13.5725 5.95245ZM13.5765 5.48056L15.1055 2.97338L13.5685 0.471665L12.0396 2.97885L13.5765 5.48056Z"
        fill="#0A3887"
      />
      <path
        d="M11.9168 10.3814C11.8821 10.3814 11.8474 10.3773 11.814 10.3691L8.99641 9.70981C8.82549 9.67015 8.69062 9.532 8.65189 9.35692L8.00825 6.47086C7.97353 6.31219 8.01893 6.14942 8.1311 6.03453C8.24327 5.91963 8.40218 5.87313 8.55708 5.90869L11.3747 6.56797C11.5443 6.60764 11.6805 6.74579 11.7192 6.92086L12.3628 9.80693C12.3976 9.96559 12.3522 10.1284 12.24 10.2433C12.1532 10.3322 12.037 10.3814 11.9168 10.3814ZM8.45292 6.37101L9.10324 9.2516L11.9182 9.90678L11.2679 7.02618L8.45426 6.37101H8.45292Z"
        fill="#0A3887"
      />
      <path
        d="M15.4229 7.95764C15.3028 7.95764 15.1879 7.90977 15.0998 7.81949C14.9876 7.7046 14.9422 7.54183 14.9769 7.38316L15.6206 4.4971C15.6593 4.32339 15.7942 4.18387 15.9651 4.14421L18.7827 3.48493C18.9376 3.448 19.0965 3.49587 19.2087 3.61076C19.3209 3.72566 19.3663 3.88843 19.3315 4.04709L18.6879 6.93316C18.6492 7.10687 18.5143 7.24638 18.3434 7.28605L15.5258 7.94533C15.491 7.95354 15.4563 7.95764 15.4229 7.95764ZM18.8815 3.94177L16.0693 4.60789L15.4296 7.49122L18.2419 6.8251L18.8815 3.94314V3.94177Z"
        fill="#0A3887"
      />
      <path
        d="M7.57678 3.54762C7.44859 3.54762 7.34576 3.44093 7.34576 3.31099V1.3564C7.34576 1.22509 7.44992 1.11977 7.57678 1.11977C7.70364 1.11977 7.8078 1.22646 7.8078 1.3564V3.31099C7.8078 3.4423 7.70364 3.54762 7.57678 3.54762Z"
        fill="#0A3887"
      />
      <path
        d="M8.15768 2.57142H6.99725C6.86906 2.57142 6.76624 2.46473 6.76624 2.33479C6.76624 2.20485 6.87039 2.09816 6.99725 2.09816H8.15768C8.28587 2.09816 8.38869 2.20485 8.38869 2.33479C8.38869 2.46473 8.28454 2.57142 8.15768 2.57142Z"
        fill="#0A3887"
      />
      <path
        d="M6.61535 12.7273C6.48716 12.7273 6.38434 12.6206 6.38434 12.4907V10.5361C6.38434 10.4048 6.4885 10.2995 6.61535 10.2995C6.74221 10.2995 6.84637 10.4061 6.84637 10.5361V12.4907C6.84637 12.622 6.74221 12.7273 6.61535 12.7273Z"
        fill="#0A3887"
      />
      <path
        d="M7.19448 11.7505H6.03406C5.90586 11.7505 5.80304 11.6438 5.80304 11.5139C5.80304 11.3839 5.9072 11.2772 6.03406 11.2772H7.19448C7.32268 11.2772 7.4255 11.3839 7.4255 11.5139C7.4255 11.6438 7.32134 11.7505 7.19448 11.7505Z"
        fill="#0A3887"
      />
      <path
        d="M21.1895 4.19093C21.0613 4.19093 20.9585 4.08424 20.9585 3.9543V1.99971C20.9585 1.8684 21.0627 1.76308 21.1895 1.76308C21.3164 1.76308 21.4205 1.86977 21.4205 1.99971V3.9543C21.4205 4.08561 21.3164 4.19093 21.1895 4.19093Z"
        fill="#0A3887"
      />
      <path
        d="M21.7686 3.2129H20.6082C20.48 3.2129 20.3772 3.10621 20.3772 2.97627C20.3772 2.84633 20.4814 2.73964 20.6082 2.73964H21.7686C21.8968 2.73964 21.9997 2.84633 21.9997 2.97627C21.9997 3.10621 21.8955 3.2129 21.7686 3.2129Z"
        fill="#0A3887"
      />
      <path
        d="M20.0287 10.7724C19.9006 10.7724 19.7977 10.6657 19.7977 10.5357V8.58113C19.7977 8.44982 19.9019 8.3445 20.0287 8.3445C20.1556 8.3445 20.2598 8.45119 20.2598 8.58113V10.5357C20.2598 10.667 20.1556 10.7724 20.0287 10.7724Z"
        fill="#0A3887"
      />
      <path
        d="M20.6085 9.79615H19.4481C19.3199 9.79615 19.217 9.68947 19.217 9.55952C19.217 9.42958 19.3212 9.3229 19.4481 9.3229H20.6085C20.7367 9.3229 20.8395 9.42958 20.8395 9.55952C20.8395 9.68947 20.7353 9.79615 20.6085 9.79615Z"
        fill="#0A3887"
      />
    </g>
    <defs>
      <clipPath id="clip0_1633_1333">
        <rect width={22} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default HopeIcon;
